export default __webpack_public_path__ + "static/media/2502113.66e5fe35.jpg";